import {connect} from "react-redux";
import PjpPendingList from "./List";
import {bindActionCreators} from "redux";
import {pjpPending, getAM, pjpPendingApprove} from "../../../../service/FasttagToll/action";
const mapStateToProps = (state) => ({
    PJPPendingList:state.FasttagToll.PJPPendingList,
    allAm:state.FasttagToll.allAm,
    PJPApprovalDetails:state.FasttagToll.PJPApprovalDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pjpPending,
            getAM,
            pjpPendingApprove
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PjpPendingList);
